import { apiClient } from '@/core/api/client';

type ChatClassification = {
  care_stage?: string;
  care_mode?: string;
  summary?: string;
  zip_code?: string;
  budget_range?: string;
};

type CareStageData = Record<string, unknown> | null;

export type LogChatResponsePayload = {
  user_id?: string | null;
  session_id: string;
  response: string;
  status: string;
  classification: ChatClassification | null;
  care_stage_data?: CareStageData;
};

export const logChatResponse = async (payload: LogChatResponsePayload): Promise<void> => {
  try {
    const requestPayload: LogChatResponsePayload = {
      ...payload,
      care_stage_data: payload.care_stage_data ?? null,
    };

    await apiClient.post('/navigator/log-chat-response', requestPayload);
  } catch (error) {
    console.error('Failed to log chat response:', error);
  }
};
